import { useContext } from 'react';
import { DarkModeContext } from '../context/DarkModeContext';
import uniFundLogo from '../assets/uni-fund-logo-clean.png';
import uniFundLogoWhite from '../assets/uni-fund-logo-white-outlined.png';

const PoweredByFooter = () => {
  const { darkMode } = useContext(DarkModeContext);

  // Always show footer for branding attribution

  return (
    <div className="fixed bottom-0 left-0 z-40 p-2 sm:p-3">
      <a
        href="https://uni-fund.com"
        target="_blank"
        rel="noopener noreferrer"
        className="flex items-center gap-1.5 px-2.5 py-1.5 rounded-lg bg-white/80 dark:bg-slate-800/80 backdrop-blur-sm border border-slate-200/60 dark:border-slate-700/60 shadow-sm hover:shadow-md transition-shadow text-xs text-slate-500 dark:text-slate-400 hover:text-slate-700 dark:hover:text-slate-200"
        title="Powered by Uni-Fund"
      >
        <span className="hidden sm:inline">Powered by</span>
        <img
          src={darkMode ? uniFundLogoWhite : uniFundLogo}
          alt="Uni-Fund"
          className="h-4 w-auto"
        />
      </a>
    </div>
  );
};

export default PoweredByFooter;